const workflowTypes = [
    { label: "No Reviewer (Minor Revision)", value: "no_reviewer" },
    { label: "One Reviewer (Minor Revision)", value: "direct_approval" },
    { label: "Two Reviewers (Major Revision)", value: "with_review" },
    { label: "Three Reviewers (Major Revision)", value: "three_reviewers" },
    { label: "Lean Review (Major Revision)", value: "lean_review" }
]

export default workflowTypes